const audioList = {
    start:'https://picbed.qunarzz.com/853068a5833a089c688853347dd5242c.mp3',
    choose:'https://picbed.qunarzz.com/699ddf6f0e8dc61160684d64f6f5126f.mp3',
    right:'https://picbed.qunarzz.com/ec723809451cab4d0f365cd3386e8ef9.mp3',
    error:'https://picbed.qunarzz.com/525076bd704a7a43b1298cfd221d65c6.mp3',
    gameend:'https://picbed.qunarzz.com/085b01d6886406dce84852f29c3a460a.mp3',
    totalReward:'https://picbed.qunarzz.com/59460284e0af358f1ab7eae2f581ca76.mp3'
}

export default (type)=>{
    var audio = document.createElement('audio');
    audio.src = audioList[type];
    audio.play();
    audio = null;
}